export const UNCATEGORIZED_FILTER = 'uncategorized';
